import { useSelector } from 'react-redux';

import { UnleashFeatureNames } from '../../modules/Unleash/featureNames';
import { getIsFeatureEnabled } from '../../selectors/features';

export default function useIsKeywordMatchingEnabled(): boolean {
  const isKeywordMatchingEnabled = useSelector(state =>
    getIsFeatureEnabled(state, UnleashFeatureNames.empAllKeywordMatching)
  );

  return isKeywordMatchingEnabled;
}
